import type { SiteEvent } from "./siteContent";

const DAY_MONTH_YEAR = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})/;

function calendarDay(year: number, month: number, day: number): number | null {
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  const sameDay =
    date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  if (!sameDay) return null;
  return date.getTime();
}

export function parseSiteEventDay(raw: string | undefined): number | null {
  const value = raw?.trim() ?? "";
  if (!value) return null;

  const dayMonthYear = DAY_MONTH_YEAR.exec(value);
  if (dayMonthYear) {
    return calendarDay(Number(dayMonthYear[3]), Number(dayMonthYear[2]), Number(dayMonthYear[1]));
  }

  const isoDay = ISO_DAY.exec(value);
  if (isoDay) {
    return calendarDay(Number(isoDay[1]), Number(isoDay[2]), Number(isoDay[3]));
  }

  return null;
}

export function pickNearestSiteEvent(events: SiteEvent[], now = new Date()): SiteEvent | null {
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const dated: { event: SiteEvent; at: number }[] = [];

  for (const event of events) {
    const at = parseSiteEventDay(event.date);
    if (at === null) continue;
    dated.push({ event, at });
  }

  const upcoming = dated.filter((item) => item.at >= todayStart);
  upcoming.sort((left, right) => left.at - right.at);
  if (upcoming.length > 0) return upcoming[0].event;

  dated.sort((left, right) => right.at - left.at);
  return dated[0]?.event ?? null;
}
